import React from "react";
import PanelBody from "../../UI/Panel/PanelBody";
import PanelHead from "../../UI/Panel/PanelHead";
import {ManagePanelsTable} from "../../UI/Main/ManagePanelsTable";

const ManagePanels = () => {
    return (
        <div>
            <PanelHead title="Manage Services" />
            <PanelBody content={<ManagePanelsTable />} />
        </div>
    );
};

export default ManagePanels;
